import React, { useState, useEffect, useRef } from "react";
import classes from "./AddTaskToUser.module.scss";
import { BTN_TYPE_TRANSPARENT } from "../../../constants/buttons";
import * as r from "../../../constants/routes";
import { useLocation } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { useTranslation } from "react-i18next";
import * as actions from "../../../store/actions";
import * as helpers from "../../../helpers";
import * as kApi from "../../../constants/api";
import ButtonNavLink from "../../../components/Buttons/ButtonNavLink";
import defaultBg from "../../../assets/images/bgs/bg.png";
import H1 from "../../../components/UI/Titles/H1/h1";
import Main from "../../../hoc/Layout/Main";
import RoundedButton from "../../../components/Buttons/RoundedButton";
import Spinner from "../../../components/UI/Spinner";
import TagCard from "../../../components/Cards/TagCard";
import UserInfo from "../../../components/UserInfo";
import GoPremium from "../../GoPremium";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faCheck,
  faExclamationTriangle,
  faCheckCircle,
} from "@fortawesome/free-solid-svg-icons";
import useFetch from "../../../hooks/useFetch";
import { getKeyGen } from "../../../helpers";
import H2 from "../../../components/UI/Titles/H2";

import ModalGlobal from "../../../components/ModalGlobal/ModalGlobal";
import processingImage from "../../../assets/images/loading.png";
import * as h from "../../../helpers/index";
import { set } from "react-ga";
import {
  Typography,
  TextField,
  Button,
  IconButton,
  Box,
  Divider,
} from "@mui/material";
import Grid from "@mui/material/Grid2";
import SearchTwoToneIcon from "@mui/icons-material/SearchTwoTone";
import { Swiper, SwiperSlide } from "swiper/react";
import { useNavigate } from "react-router-dom";
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/navigation";
import "swiper/swiper-bundle.css";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import CancelOutlinedIcon from "@mui/icons-material/CancelOutlined";
import ReportProblemTwoToneIcon from "@mui/icons-material/ReportProblemTwoTone";
import AButton from "../../../components/UI/Inputs/MUI/ATextField/AButton";
import { color } from "framer-motion";

const AAddTaskToUser = ({ activity, setActivity, changeTab }) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [taskActivity, setTaskActivity] = useState(null);
  const { activeUser, session } = useSelector((state) => state.session);
  // const { plans, plans_error } = useSelector((state) => state.plans);
  const plans = session?.plans;
  const { mapActivities, activities_error } = useSelector(
    (state) => state.activities
  );
  const isFree = h.checkIsShowingModalLimit(session);

  const modalRef = useRef();



  useEffect(() => {
    if (activity) {
      setTaskActivity(activity);
    }
  }, [activity]);

  const [selectedUsers, setSelectedUsers] = useState([]);

  const [users, isLoadingUsers, errorUsers, fetchUsersTask] = useFetch({
    autoInit: false,
  });

  const [saveTask, isLoadingSaveTask, errorSaveTask, fetchSaveTask] = useFetch({
    autoInit: false,
  });

  const [searchTerm, setSearchTerm] = useState("");
  
  // fazer o fetch depois q add task
  // useEffect(() => () => dispatch(actions.fetchTasksSuccess(null)), [dispatch]);
  // useEffect(() => {
  //   if (!tasks) {
  //     dispatch(actions.initFetchTasks(activeUser));
  //   }
  // }, [dispatch, activeUser]);

  const checkUsersHasTask = (taskID) => {
    fetchUsersTask({
      url: kApi.GET_API_Q_USERS_HAS_TASK(taskID),
      method: "GET",
    });
  };

  const submitSubListHandler = (id = null, subsList = []) => {
    
    if (id && subsList && subsList.length > 0) {
      fetchSaveTask({
        url: kApi.API_Q_TASK_USERS,
        method: "POST",
        onSuccess: () => {setSelectedUsers([]);dispatch(actions.initFetchTasks(activeUser))},
        data: {
          subs: subsList,
          game_id: id,
          level: "3",
          goal_score: "95",
          goal_time: "00:01:00",
          playing_time: "00:01:00",
          frequency: "30",
          frequency_preset: "every_other_day",
          frequency_period: "mornings",
          valid_until: "2020-09-19 00:00:00",
        },
      });
    }
  };

  const SaveTaskToUser = (user, task) => {
    
    if (user && task) {
      fetchSaveTask({
        url: kApi.API_Q_TASK,
        method: "POST",
        onSuccess: () => dispatch(actions.initFetchTasks(activeUser)),
        data: {
          sub: user.sub,
          game_id: task.id,
          level: "",
          goal_score: "",
          goal_time: "",
          playing_time: "",
          frequency: "",
          frequency_preset: "",
          frequency_period: "",
          valid_until: "",
        },
      });
    }
  };

  const getListUsersButtons = (users = null, title = null) => {
    let _content = null;
    let _title = null;
    if (title) _title = <Typography>{title ?? ""}</Typography>;
    if (users && users.length > 0) {
      _content = (
        <div className={classes.UserList}>
          {_title}
          {users.map((user) => {
            // Start Starting variables --------------
            const { sub, given_name, has_task, email } = user;
            let btnClass = classes.UserLabelCard;
            // END Starting variables --------------

            if (selectedUsers.includes(sub)) btnClass += " " + classes.Selected;

            if (has_task) {
              btnClass += " " + classes.HasTheTask;
            }
            let _innerContent = (
              <UserInfo
                className={classes.Item}
                name={given_name}
                email={email}
              />
            );
            return (
              <button
                key={getKeyGen(given_name)}
                className={btnClass}
                onClick={() => (has_task ? null : addUserToListHandler(sub))}
              >
                {_innerContent}
                <FontAwesomeIcon
                  className={has_task ? classes.IconHasAdd : classes.Icon}
                  icon={has_task ? faCheckCircle : faCheck}
                />
              </button>
            );
          })}
        </div>
      );
    }
    return _content;
  };

  const addUserToListHandler = (sub = null) => {
   
    let tempSelectedUsers = [...selectedUsers];
    if (tempSelectedUsers.includes(sub))
      tempSelectedUsers = tempSelectedUsers.filter((item) =>
        item === sub ? false : true
      );
    else tempSelectedUsers.push(sub);
    setSelectedUsers(tempSelectedUsers);
  };

  // useEffect(() => {
  //   console.log("selectedUsers", selectedUsers);
  // }, [selectedUsers]);

  const renderGoPremium = () => (
    <GoPremium
      title={"global.goPremiumAddTaskTitle"}
      info={"global.goPremiumAddTaskInfo"}
    />
  );

  const renderTaskSuccess = (text = 1) => (
    <Grid container spacing={2}>
      <Grid item size={12}>
        <CheckCircleIcon color="success" sx={{ fontSize: 70 }} />
      </Grid>
      <Grid item size={12}>
        <Typography variant="body1">
          {text == 1
            ? t("newActivities.add_task_users_success")
            : t("newActivities.add_task_users_success")}
        </Typography>
      </Grid>
    </Grid>
  );

  const renderErrorContent = (_errorSaveTask) => (
   
    (
      <Grid container spacing={2}>
        <Grid item size={12}>
          <ReportProblemTwoToneIcon color="primary" sx={{ fontSize: 50 }} />
        </Grid>

        <Grid item>
          {_errorSaveTask ? (
            <>
              <Typography>{t("global.error_to_save")}</Typography>
              <Typography>{t("msg_error.unidentifiedException")}</Typography>
            </>
          ) : (
            <>
              <Typography>
                {t("msg_error.error_to_load_users_list_top")}
              </Typography>
              <Typography>
                {t("msg_error.error_to_load_users_list_bottom")}
              </Typography>
            </>
          )}
        </Grid>
      </Grid>
    )
  );

  const renderAddTask = (_activeUser, _taskActivity) => {
    return (
      <Grid container sx={{mt:2}}>
        <Grid item size={12}>
          <Typography variant="h6">
            {t("newActivities.confirm_add_task")}
          </Typography>
          <Typography variant="h6" color="primary" sx={{ fontWeight: "semibold" }}>
            {_taskActivity?.name}
          </Typography>
          <Typography variant="h6">{t("newActivities.to_user")}</Typography>
          <Typography variant="h6" color="primary" sx={{ fontWeight: "semibold" }}>
            {_activeUser?.given_name} ?
          </Typography>
        </Grid>
      </Grid>
    );
  };

  const renderUserSelection = (_users, _taskActivity) => {
    const filteredUsers = _users.filter((user) =>
      [user.given_name, user.email].some((value) =>
        value?.toLowerCase().includes(searchTerm?.toLowerCase())
      )
    );
    filteredUsers.sort((a, b) => {
      return a.has_task ? 1 : -1;
    });
    return (
      <Grid
        container
        spacing={1}
        sx={{ justifyContent: "center", ml: 2, mb: 2, mr: 2 }}
      >
        <Grid item size={12} sx={{ mb: 2 }}>
          <TextField
            fullWidth
            placeholder="Procurar por nome ou email"
            variant="outlined"
            size="small"
            onChange={(e) => setSearchTerm(e.target.value)}
            value={searchTerm}
            InputProps={{
              startAdornment: <SearchTwoToneIcon color="primary" />,
            }}
          />
        </Grid>

        <Grid item size={12}>
          {getListUsersButtons(filteredUsers)}
        </Grid>

        <Grid
          size={10}
          container
          spacing={2}
          sx={{
            alignContent: "center",
            justifyContent: "center",
            display: "flex",
          }}
        >
          {selectedUsers.length > 0 ? (
            <Grid item size={{ xs: 12, sm: 6 }}>
              <AButton
                onClick={() => setSelectedUsers([])}
                color="primary"
                variant="outlined"
                sx={{ width: "100%" }}
              >
                {t("global.clear")}
              </AButton>
            </Grid>
          ) : null}
          <Grid item size={{ xs: 12, sm: 6 }}>
            <AButton
              onClick={() =>
                submitSubListHandler(_taskActivity.id, selectedUsers)
              }
              color="secondary"
              variant="contained"
              sx={{ width: "100%" }}
            >
              {t("global.confirm")}
            </AButton>
          </Grid>
          {/* <RoundedButton
            onClick={() =>
              submitSubListHandler(_taskActivity.id, selectedUsers)
            }
            text={t("global.confirm")}
          /> */}
        </Grid>
      </Grid>
    );
  };

  const renderUnidentifiedError = () => (
    <>
      <div className={`${classes.IconHugeError} center`}>
        <FontAwesomeIcon icon={faExclamationTriangle} />
      </div>
      <H1 huge className={classes.Title}>
        {t("msg_error.unidentifiedException")}
      </H1>
      <div className={`${classes.BtnsArea} center`}>
        <ButtonNavLink
          to={r.R_ACTIVTS_ALL}
          text={t("global.back_to_all_activities")}
          btnType={BTN_TYPE_TRANSPARENT}
        />
      </div>
    </>
  );

  const renderHeader = (_taskActivity, subtitle) => {
    const content = {
      titleTypographyProps: {
        fontWeight: "bold",
        fontSize: "1.2rem",
        color: "primary.main",
      },
      title: _taskActivity.name,
      sx: { ml: 2, mt: 2, mr: 2 },
      subheader: subtitle,
      action: (
        <IconButton onClick={() => setOpenStateModalGlobal(false)} sx={{ p: 0 }}>
          <CancelOutlinedIcon color="primary" sx={{ fontSize: 40 }}/>
        </IconButton>
      ),
    };

    return content;
  };

  useEffect(() => {
    let nextModalIndex = 5; // padrão 5 é o loading
    if (isLoadingSaveTask) {
      nextModalIndex = 5;
    } else if (saveTask && !activeUser) {
      nextModalIndex = 2;
    } else if (activeUser) {
      nextModalIndex = 7;
    }
    modalRef.current.nextModal(nextModalIndex);
  }, [isLoadingSaveTask, saveTask, errorSaveTask, activeUser]);

  useEffect(() => {
    let nextModalIndex = 5; // padrão 5 é o loading
    // return modalRef.current.nextModal(2);
    if (taskActivity && users && !activeUser) {
      nextModalIndex = 0;
    } else if (isFree) {
      nextModalIndex = 1;
    } else if (errorUsers) {
      nextModalIndex = 3;
    } else if (activeUser) {
      nextModalIndex = 6;
    }

    // console.log("nextModalIndex", nextModalIndex);
    modalRef.current.nextModal(nextModalIndex);
  }, [isFree, errorUsers, taskActivity, users]);

  const [openStateModalGlobal, setOpenStateModalGlobal] = useState(null);
  const [modalConfigs, setModalConfigs] = useState(null);

  useEffect(() => {
    if (taskActivity) {
      checkUsersHasTask(taskActivity?.id);
    }
  }, [taskActivity]);

  useEffect(() => {
    // console.log("users", users);
    // console.log("taskActivity", taskActivity);
    if (taskActivity)
      setModalConfigs([
        {
          title: "Selecione os usuários",
          header: renderHeader(
            taskActivity,
            t("global.select_users_to_add_to_a_game")
          ),
          size: "Medium",
          modalStateOpen: true,
          content: users ? renderUserSelection(users, taskActivity) : null,

          scheme: ["header", "divider", "content"],
        },
        {
          title: "Vire Premium",
          modalStateOpen: true,
          content: renderGoPremium(),
          actions: [{ type: "cancel", text: t("newActivities.close") }],
          scheme: ["header", "content", "actions"],
        },
        {
          title: "Tarefa Adicionada!",
          modalStateOpen: true,
          content: renderTaskSuccess(),
          customActions: {
            sx: { display: "flex", justifyContent: "center", gap: 2 },
          },
          actions: [
            // {
            //   type: "custom",
            //   variant:"outlined",
            //   text: t("newActivities.add_more_user"),
            //   callback: () => {
            //     modalRef.current.nextModal(0);
            //   },
            // },
            { type: "cancel", text: t("newActivities.close") },
          ],
          scheme: ["header", "content", "customActions"],
        },
        {
          title: "Atenção",
          modalStateOpen: true,
          content: renderErrorContent(errorSaveTask),
          actions: [
            errorUsers && {
              type: "custom",
              text: t("newActivities.bind_users"),
              callback: () => navigate("/convidar-usuario"),
            },
            { type: "cancel", text: t("newActivities.close") },
          ],
          scheme: ["header", "content", "actions"],
        },

        {
          title: "Erro",
          modalStateOpen: true,
          content: renderUnidentifiedError(),
          actions: [{ type: "cancel", text: t("newActivities.close") }],
          scheme: ["header", "content", "actions"],
        },
        {
          title: "",
          modalStateOpen: true,
          header: true,
          media: { image: processingImage, title: "processing", rotate: true },
          title: t("newActivities.processing_add_task"),
          content: "Processando...",
          actions: [{ type: "cancel", text: t("newActivities.close") }],
          scheme: ["header", "media", "content"],
        },
        {
          title: "Adicionar Tarefa",
          size: "Medium",
          modalStateOpen: true,
          content: activeUser ? renderAddTask(activeUser, taskActivity) : null,
          customActions: {
            sx: { display: "flex", justifyContent: "center", gap: 2 },
          },
          actions: [
            { type: "cancel", text: t("newActivities.close") },
            {
              type: "custom",
              variant: "contained",
              color: "secondary",
              sx:{fontWeight: "bold", width: "100%"},
              text: t("newActivities.confirm"),
              callback: () => {
                SaveTaskToUser(activeUser, taskActivity);
              },
            },
          ],
          scheme: ["header", "divider", "content","customActions"],
        },
        {
          title: "Tarefa Adicionada!",
          modalStateOpen: true,
          size: "Medium",
          content: renderTaskSuccess(2),
          customActions: {
            sx: { display: "flex", justifyContent: "center", gap: 2 },
          },
          actions: [
            { type: "cancel", text: t("newActivities.back_to_activities") },
            {
              type: "custom",
              variant: "outlined",
              text: t("newActivities.see_my_activities"),
              callback: () => {
                setOpenStateModalGlobal(false);
                changeTab("", "MyActivities");
              },
            },
          ],
          scheme: ["header", "content", "customActions"],
        },
      ]);
  }, [
    users,
    taskActivity,
    activeUser,
    errorUsers,
    errorSaveTask,
    isFree,
    searchTerm,
    selectedUsers,
  ]);

  useEffect(() => {
    // console.log("modalConfigs addtask", modalConfigs);
    if (modalConfigs) {
      setOpenStateModalGlobal(true);
    }
  }, [modalConfigs]);

  useEffect(() => {
    if (openStateModalGlobal === false) {
      setOpenStateModalGlobal(null);
      setTaskActivity(null);
      setActivity(null);
      setSelectedUsers([]);
    }
  }, [openStateModalGlobal]);

  return (
    <ModalGlobal
      currentModal={0}
      ref={modalRef}
      openState={openStateModalGlobal}
      setOpenState={setOpenStateModalGlobal}
      modalConfigs={modalConfigs}
    />
  );
};

export default AAddTaskToUser;
